import React, { useState } from 'react';
import { Button, InlineLoading } from 'carbon-components-react';
import { CloudDownload16, View16, Download20 } from '@carbon/icons-react';
import AutodeskViewer from 'components/AutodeskViewer';
import { getEmailAttachment } from 'utilities/helper.util';

const DWFViewer: React.FC<Props> = ({
  showViewer,
  setShowViewer,
  title,
  isSuperModal,
  dataBody,
  enquiryId,
  fileId
}) => {
  const [isDWFLoaded, setDWFLoaded] = useState<boolean>(false);
  const [isDWFError, setDWFError] = useState<boolean>(false);

  return (
    <div className="dwf-viewer">
      <div
        className={`dwf-viewer-header${
          isSuperModal ? ' supermodal-header' : ''
        }`}
      >
        <div className="dwf-viewer-header-file-name">{title}</div>
        {showViewer && (
          <div className="dwf-viewer-header-controls">
            <div
              title="Download DWF file"
              className="dwf-viewer-header-controls-btn"
              onClick={() =>
                getEmailAttachment({
                  url: dataBody || '',
                  attachmentName: title || ''
                })
              }
            >
              <Download20 />
            </div>
          </div>
        )}
      </div>
      <div
        className={`dwf-viewer-content${
          isSuperModal ? ' dwf-viewer-supermodal-content' : ''
        }`}
      >
        {showViewer ? (
          <>
            {fileId && (
              <AutodeskViewer
                fileId={String(fileId)}
                enquiryId={enquiryId}
                onDocumentError={() => {
                  setShowViewer(false);
                  setDWFError(true);
                }}
                onDocumentLoaded={() => setDWFLoaded(true)}
              />
            )}
            {!isDWFLoaded && (
              <div className="dwf-viewer-loader">
                <InlineLoading description="Preparing response view ..." />
              </div>
            )}
          </>
        ) : (
          <div className="dwf-viewer-content-preview-container">
            <div className="dwf-viewer-content-preview">
              {isDWFError ? (
                <div className="dwf-viewer-content-preview-text error">
                  Unable open in viewer, please try again or download the file
                </div>
              ) : (
                <div className="dwf-viewer-content-preview-text">
                  How do you want to view this file?
                </div>
              )}
              <div className="dwf-viewer-content-preview-btns">
                <Button
                  kind="tertiary"
                  renderIcon={View16}
                  onClick={() => {
                    setDWFError(false);
                    setShowViewer(true);
                  }}
                >
                  Open in DWF viewer
                </Button>
                <Button
                  kind="tertiary"
                  renderIcon={CloudDownload16}
                  onClick={() => {
                    setDWFError(false);
                    getEmailAttachment({
                      url: dataBody || '',
                      attachmentName: title || ''
                    });
                  }}
                >
                  Download DWF file
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

type Props = {
  showViewer: boolean;
  setShowViewer: Function;
  title?: string;
  isSuperModal?: boolean;
  dataBody?: string;
  fileId?: number;
  enquiryId?: number;
};

export default React.memo(DWFViewer);
